import { MessageTypeSelect, SettingsSectionHeader } from '../common';
import { displayContent } from '../common/content';
import { DataFeedsFormSection } from '../common/DataFeedsFormSection';
import { LinkParametersFormSection } from '../common/LinkParametersFormSection';
import { GoogleAnalyticsFormSection } from '../common/GoogleAnalyticsFormSection';
import { ShortenAndTrackLinksFormSection } from './formFields/ShortenAndTrackLinksFormSection';
import { SMSContactCardFormSection } from './formFields/SMSContactCardFormSection';
import { SMSMediaUrlInput } from './formFields/SMSMediaUrlInput';
import { MessageTextArea } from './formFields/MessageTextArea';
import { SMSSenderSelect } from './formFields/SMSSenderSelect';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateNameField } from '../common/TemplateNameField';
import { useSMSLinkShortening } from './context/SMSLinkShorteningContext';

export const SettingsForm = () => {
  const { campaignId } = useQueryParamContext();
  const isCampaignFlow = !!campaignId;
  const { isSMSLinkShorteningEnabled } = useSMSLinkShortening();

  return (
    <>
      {isCampaignFlow && (
        <>
          <SettingsSectionHeader>{displayContent.templateInformation}</SettingsSectionHeader>
          <TemplateNameField />
        </>
      )}

      <SettingsSectionHeader data-test="sending-info-section-header">
        {displayContent.headerSendingInformation}
      </SettingsSectionHeader>
      <MessageTypeSelect />
      <SMSSenderSelect />
      <SettingsSectionHeader data-test="content-section-header">
        {displayContent.headerContent}
      </SettingsSectionHeader>
      <MessageTextArea />
      <SMSMediaUrlInput />
      <SMSContactCardFormSection />
      <DataFeedsFormSection />
      <SettingsSectionHeader data-test="links-section-header">
        {displayContent.headerLinks}
      </SettingsSectionHeader>
      <ShortenAndTrackLinksFormSection />
      <GoogleAnalyticsFormSection isLinkShorteningEnabled={isSMSLinkShorteningEnabled} />
      <LinkParametersFormSection isLinkShorteningEnabled={isSMSLinkShorteningEnabled} />
    </>
  );
};

export default SettingsForm;
